import { environment } from '@environments/environment';

export class Uris {
  public static API_ENDPOINT = environment.API_ENDPOINT;

  public static API_LOGIN = `${Uris.API_ENDPOINT}auth/login/`;
  public static API_LOGOUT = `${Uris.API_ENDPOINT}auth/logout/`;
  public static API_ADMINS = `${Uris.API_ENDPOINT}admins/`;
  public static API_USERS = `${Uris.API_ENDPOINT}users/`;
  public static API_COURIERS = `${Uris.API_ENDPOINT}couriers/`;
  public static API_WAREHOUSE_STAFF = `${Uris.API_ENDPOINT}warehouse-staff/`;
  public static API_SALES_STAFF = `${Uris.API_ENDPOINT}sales-staff/`;
  public static API_SUPERVISORS = `${Uris.API_ENDPOINT}supervisors/`;

  /* CONTROL DE OPERACIONES */
  public static API_RETAIL_CHAINS = `${Uris.API_ENDPOINT}retail-chains/`;
  public static API_STORES = `${Uris.API_ENDPOINT}stores/`;
  public static API_SECTORS = `${Uris.API_ENDPOINT}sectors/`;
  public static API_ROUTES = `${Uris.API_ENDPOINT}routes/`;
  public static API_SALES = `${Uris.API_ENDPOINT}sales/`;
  public static API_NO_SALES_REASONS = `${Uris.API_ENDPOINT}no-sales-reasons/`;
  public static API_LOGISTICS = `${Uris.API_ENDPOINT}logistics/`;

  public static API_ROSES = `${Uris.API_ENDPOINT}roses/`;
  public static API_ROSE_CHAIN_PRICES = `${Uris.API_ENDPOINT}rose-chain-prices/`;
  public static API_GLOBAL_CONFIG = `${Uris.API_ENDPOINT}global-config/`;

  public static API_COURIER_SHIPMENTS_ITEM = `${Uris.API_ENDPOINT}courier-shipments/`;
  public static API_INVENTORY = `${Uris.API_ENDPOINT}inventory/`;
  public static API_POINTS_OF_PRESENCE = `${Uris.API_ENDPOINT}points-of-presence/`;
  public static API_LOGISTIC_REPORTS = `${Uris.API_ENDPOINT}logistic-reports/`;
  public static API_SUGGESTED = `${Uris.API_ENDPOINT}suggested-calculator/calculate/`;
  public static API_SUGGESTED_EXCEL = `${Uris.API_ENDPOINT}suggested-calculator/calculate-excel/`;
  public static API_SUGGESTED_APPLY = `${Uris.API_ENDPOINT}suggested-calculator/apply/`;
  public static API_SUGGESTED_OVERRIDES = `${Uris.API_ENDPOINT}suggested-history/`;
  public static API_SUGGESTED_HISTORY = `${Uris.API_ENDPOINT}suggested-change-logs/`;
  public static API_STORE_SUGGESTED = `${Uris.API_ENDPOINT}store-suggesteds/`;
  public static API_ALERT_HISTORY = `${Uris.API_ENDPOINT}alert-history/`;

  /* ANALISIS DE DATOS */
  public static API_SALES_ANALYTICS_DASHBOARD = `${Uris.API_ENDPOINT}sales-analytics/dashboard-summary/`;
  public static API_SALES_ANALYTICS_RANKING = `${Uris.API_ENDPOINT}sales-analytics/ranking-summary/`;
  public static API_SALES_ANALYTICS_CITY = `${Uris.API_ENDPOINT}sales-analytics/city-summary/`;
  public static API_SALES_ANALYTICS_ROUTE = `${Uris.API_ENDPOINT}sales-analytics/route-summary/`;
  public static API_SALES_ANALYTICS_STORE = `${Uris.API_ENDPOINT}sales-analytics/store-summary/`;

  public static API_SEPOMEX = `https://sepomex.icalialabs.com/api/v1/`;

  public static PASSWORD_SENDREQUEST = `${Uris.API_ENDPOINT}password-reset/send_request/`;
  public static PASSWORD_CONFIRM = `${Uris.API_ENDPOINT}password-reset/confirm_request/`;
}
